export default __webpack_public_path__ + "static/media/spotlight_autochtone_664x830_fr.28cedb0f.jpg";